window.markAsReadFormatter = function(value, row) {
    let html = ''
    if (row.allow_mark !== 1) {
        return html;
    }
    html += '<a href="#" class="action-mark-as-read" data-id="'+row.id+'" title="'+__('Mark as read')+'" data-toggle="tooltip" data-placement="top">'
    html += '<i class="fontawesome fas fa-check"></i>'
    html += '</a>'
    return html;
};
